var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 152 152",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "02.YouTube"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.46 88.26 21.08-12.23-21.08-12.29z",
    fill: "#551067",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 0a76 76 0 1 0 76 76A76 76 0 0 0 76 0zm40 89.45a15.13 15.13 0 0 1-15.13 15.14H51.13A15.13 15.13 0 0 1 36 89.45v-26.9a15.13 15.13 0 0 1 15.13-15.14h49.74A15.13 15.13 0 0 1 116 62.55z",
    fill: "#551067",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a5f3d8f7f39608b9f543a4681979c61c.svg";
export { ForwardRef as ReactComponent };